import { AxiosResponse } from "axios";

import {
  IPatientTreatment,
  IPatientTreatmentError,
  ITreatmentSummary,
} from "../../@types/admin/AdminTreatment";
import { api } from "../api";

/**
 * Treatments admin page (EN-5156), migrated from the Retool Treatments app
 * plus `modulePatientTreatments`. All three endpoints accept optional filters
 * (serial number, date range, dose status); Retool sent none and paged the
 * results client-side, so these fetch the whole set the same way.
 */
export const treatmentsService = {
  /** Cross-patient summary: treatment and error counts per patient. */
  async getTreatmentsSummary(): Promise<AxiosResponse<ITreatmentSummary[]>> {
    return api.get<ITreatmentSummary[]>("/Retool/Treatments");
  },

  /** Device error log for one patient. */
  async getPatientTreatmentErrors(
    patientId: number
  ): Promise<AxiosResponse<IPatientTreatmentError[]>> {
    return api.get<IPatientTreatmentError[]>(
      `/Retool/Treatments/${patientId}/Errors`
    );
  },

  /** Treatments for one patient — the shared `PatientTreatmentsPanel`. */
  async getPatientTreatments(
    patientId: number
  ): Promise<AxiosResponse<IPatientTreatment[]>> {
    return api.get<IPatientTreatment[]>(`/Retool/Treatments/${patientId}`);
  },
};
